import { AxiosClient } from 'src/api/AxiosClient';

export class AuthoritiesAPI {
  static async getAuthorities () {
    return AxiosClient.get('/authorities');
  }
}
